import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["options"];

  toggle(event) {
    const show = event.target.value === "yes";
    this.optionsTarget.classList.toggle("d-none", !show);

    if (!show) {
      this.optionsTarget.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
        cb.checked = false;
      });
    }
  }
}
